import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "nav_right",
  "use": "nav_right-usage",
  "viewBox": "0 0 8 10",
  "content": "<symbol viewBox=\"0 0 8 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"nav_right\"><path d=\"M3.83 1.33L5.66 5 3.83 8.67a.742.742 0 00.33 1c.37.19.82.04 1.01-.34L7.34 5 5.17.67A.763.763 0 004.16.33c-.37.18-.52.63-.33 1zm-1.66 8L4.34 5 2.17.67A.763.763 0 001.16.33C.79.52.64.97.82 1.34L2.66 5 .83 8.67a.742.742 0 00.33 1c.38.19.83.04 1.01-.34z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol